module.exports = __webpack_public_path__ + "img/partnership_07_mobile.cfbb51b1.jpg";